import { BaseEntite, BaseEntiteSommaireStatique, BaseEntiteStatique } from '../../../../../common/src/entities';

export interface FilterInfo<T> {
    key: keyof T;
    value?: any;
    notes?: string;
};

export interface InjectionReference<T1, TEntite extends BaseEntite = BaseEntite, T2 = void, TEntite2 extends BaseEntite = BaseEntite> {
    entite?: BaseEntiteStatique<TEntite>;
    modelSommaire?: BaseEntiteSommaireStatique<TEntite>;
    ref?: (InjectionReference<T1 | T1[keyof T1], TEntite>) | (InjectionReference<T2 | T2[keyof T2], TEntite2>);
    filterInfo?: FilterInfo<T1>;
    filterCallBack?: (values: T1 | T1[], filterInfo?: FilterInfo<T1>) => T1 | T1[keyof T1];
    notes?: string;
};

function defaultFilterCallback<T>(itemToFilter: T | T[] | undefined, filterInfo?: FilterInfo<T>): T | T[keyof T] | undefined {
    let foundItem: T | T[keyof T] | undefined;

    if (itemToFilter && Array.isArray(itemToFilter)) {
        if (filterInfo) {
            const filteredValues = itemToFilter.filter((item: T) => item[filterInfo.key] === filterInfo.value)
            foundItem = filteredValues.length ? filteredValues[0] : undefined;
        } else {
            foundItem = itemToFilter.length ? itemToFilter[0] : undefined;
        }
    } else if (itemToFilter) {
        if (filterInfo) {
            foundItem = filterInfo.key in itemToFilter ? itemToFilter[filterInfo.key] : itemToFilter;
        } else {
            foundItem = itemToFilter
        }
    }

    return foundItem;
}

export function resolveInjectionRef<TInjection, TEntite extends BaseEntite = BaseEntite>(
    fromValue: TInjection | TInjection[],
    injectionRef: InjectionReference<TInjection, TEntite>,
): TInjection | TInjection[keyof TInjection] | undefined {
    return injectionRef.filterCallBack 
            ? injectionRef.filterCallBack(fromValue, injectionRef.filterInfo) 
            : defaultFilterCallback<TInjection>(fromValue, injectionRef.filterInfo);
}
